import { useIsReadOnly } from '@retailer-platform/dashboard/access-control'
import { Permission } from '../access-control/permissions'
import { useDomainAccessControl } from './domain/accessControl'

export const useHasModifyHoursAccess = () => {
  const hasAccess = useDomainAccessControl()
  const canModifyHours = hasAccess({ permissions: [Permission.WarehouseLocationHoursModify] })

  const isReadOnly = useIsReadOnly()

  return canModifyHours && !isReadOnly
}
